import React from 'react'
import LibraryPosts from '../../staticQueries/libraryPosts'
import LanguagesPosts from '../../staticQueries/languagesPosts'
import InnovationPosts from '../../staticQueries/kainotomiaPosts'
import HealthPosts from '../../staticQueries/healthPosts'
import AncientMessiniPosts from '../../staticQueries/ancientMessiniPosts'
import HighlightsPosts from '../../staticQueries/highlightsPosts'
import GamificationPosts from '../../staticQueries/gamificationPosts'
import EtwinningPosts from '../../staticQueries/etwinningPosts'
import TfisPosts from '../../staticQueries/tfisPosts'
import ErasmusFresshPosts from '../../staticQueries/erasmusFresshPosts'
import ErasmusStatisticsPosts from '../../staticQueries/erasmusStatisticsPosts'

const RelatedPosts = ({ blogCategory, blogTags }) => {
    switch (blogTags) {
        case 'library':
            return <LibraryPosts category={blogCategory} />
        case 'languages':
            return <LanguagesPosts category={blogCategory} />
        case 'kainotomia':
            return <InnovationPosts category={blogCategory} />
        case 'health':
            return <HealthPosts category={blogCategory} />
        case 'highlights':
            return <HighlightsPosts category={blogCategory} />
        case 'ancient_messini':
            return <AncientMessiniPosts category={blogCategory} />
        case 'gamification':
            return <GamificationPosts category={blogCategory} />
        case 'etwinning':
            return <EtwinningPosts category={blogCategory} />
        case 'tfis':
            return <TfisPosts category={blogCategory} />
        case 'erasmus_fressh':
            return <ErasmusFresshPosts category={blogCategory} />
        case 'erasmus_statistics':
            return <ErasmusStatisticsPosts category={blogCategory} />
        default:
            return <div></div>
    }
}

export default RelatedPosts
